import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const AuctionProcess = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const sectionData = labels.menuPages?.sellCar?.auctionProcess || {};
  const processSteps = sectionData.steps || [];

  return (
    <div className="bg-gradient-to-br from-blue-500 via-purple-600 to-indigo-700 rounded-3xl p-12 text-white">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div>
          <h3 className="text-3xl font-bold mb-6">
            {sectionData.title || "Så Fungerar Auktionen"}
          </h3>
          <div className="space-y-6">
            {processSteps.map((step, index) => (
              <div key={index} className="flex items-start">
                <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center mr-4 mt-1">
                  <span className="text-sm font-bold">{index + 1}</span>
                </div>
                <div>
                  <h4 className="text-xl font-semibold mb-2">{step.title}</h4>
                  <p className="opacity-90">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="relative">
          <img
            src="/assets/bidding_example.png"
            alt="Auktionssida med budgivning och fordonsdetaljer"
            className="w-full h-auto rounded-2xl shadow-lg"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
};

export default AuctionProcess;
